<script>
import Multiselect from 'vue-multiselect';
import UpdateUrlMixin from './mixins/update-url';

export default {
  name: 'FilterListOption',
  mixins: [UpdateUrlMixin],
  components: { Multiselect },
  props: {
    option: { type: Object, required: false },
    values: { type: Array, required: false },
  },
  data() {
    return { selectedValues: [] };
  },
  computed: {
    name() { return this.option?.name?.toLowerCase(); },
  },
  methods: {
    addOptionValue(value, optionId) {
      this.goToModifiedOptionsURL(optionId, (values) => {
        if (!values.includes(value.id)) values.push(value.id);
        return values;
      });
    },
    deleteOptionValue(value, optionId) {
      this.goToModifiedOptionsURL(optionId, (values) => {
        const index = values.indexOf(String(value.id));
        if (index !== -1) values.splice(index, 1);
        return values;
      });
    },
  },
  watch: {
    property: {
      handler() {
        if (!this.option) return;
        this.selectedValues = this.option.selectedValues;
      },
      immediate: true,
    },
  },
};
</script>

<template>
  <div
    v-if="option && values.length > 0"
    class="block bg-gray-diagomics-light py-2 mt-4"
  >
    <div class="text-gray-800 text-sm px-2 pb-2 border-b-2 border-white">
      {{ $t(name) }}
    </div>
    <div class="mt-2 px-2">
      <Multiselect v-model="selectedValues"
                    :options="values"
                    label="name"
                    track-by="id"
                    :placeholder="$t(name)"
                    :select-label="''"
                    :deselect-label="''"
                    :multiple="true"
                    :allow-empty="true"
                    @select="addOptionValue"
                    @remove="deleteOptionValue"
                    :id="option.id"
      >
      </Multiselect>
    </div>
  </div>
</template>
